//获取当前时间
import Lockr from 'lockr'
const now = new Date();
const state = {
    //保存的数据
    list: [],
    // 外科
    // 手术医生13// 实际手术医生13
    list13: [],
    // 处方医生
    // 麻醉师11
    list11: [],
    // 麻醉方式2
    list2: [],
    cityCode: Lockr.get('cityCode') == null ? '' : Lockr.get('cityCode'),
    areaType: Lockr.get('areaType') == undefined || !Lockr.get('areaType') ? '' : Lockr.get('areaType'),
    // 客服
}

export default state